export default (value) => {
  return errorCodes[value] ? errorCodes[value] : value
}

const errorCodes = {
  RATE_LIMIT_EXCEEDED: 'The login rate limit has been exceeded.',
  FAILED_LOGIN_LOCK: 'Too many login attempts. The account has been locked for the next 30 minutes.',
  INVALID_CREDENTIALS: 'The login provided is not valid.',
  DELETED_USER: 'The provided User has been deleted and is no longer allowed to login.',
  ALREADY_EXISTS: 'The provided Email is already in use.'
}
